import { getSPDataWithParams } from './services'

export async function getSupportClinicBrandCommunicationSummary(clinicBrandIds = []) {
  const joinedIds = (clinicBrandIds || [])
    .filter(Boolean)
    .join(',')

  if (!joinedIds) {
    return null
  }

  return getSPDataWithParams('/api/secure/cc/support/clinic-brand/communication-summary/list', {
    clinicBrandIds: joinedIds,
  })
}
